<template>
  <div class="all">
    <h2 class="large-title">Campaigns</h2>
    <div class="all__filter">
      <adx-selectdropdown @selected="selectStatus" :label="`Status`" :options="statusList" />
    </div>
      <button class="btn-large secondary" @click="download">Download</button>
  </div>
</template>

<script>
import SelectDropdown from '@/components/Form/SelectDropdown'
import Loading from '@/components/Loading/Secondary'
import calendar from 'v-calendar'
import moment from 'moment';
import api from '@/api'
import { apiV2 } from '@/api/urls'

export default {
  name: 'adx-admin-all_campaigns',
  components: {
    'v-calendar': calendar,
    'adx-selectdropdown': SelectDropdown,
  },
  props: {

  },
  data() {
    return {
      startDate: null,
      endDate: new Date(),
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
        dayCellNotInMonth: {
          opacity: 0,
        }
      },
      statusList: [
        {
          "id": 1,
          "value": "",
          "label": "All Status"
        },
        {
          "id": 2,
          "value": "first",
          "label": "First Campaign"
        },
      ],
    }
  },
  computed: {
    
  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    download() {
      if (this.selectedStatus == "first") {
        window.location = apiV2.firstCampaign
      } else {
        window.location = apiV2.campaignsReport
      }
    },
    selectStatus(item) {
      this.selectedStatus = item.item.value
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>